import CavAbstractDocument from "./cav-abstract-document";
import { Model } from './abstract-model';

@Model('CavDocument')
export default class CavDocument extends CavAbstractDocument {
  public reference: string = null;
  public auteurs: string = null;

  public getDownloadPath(): string {
    return "document";
  }
}
